import SettingsAvailabilityModule from './settings-availability.module'

export default SettingsAvailabilityModule
